import { createHttpEndpoint } from '../../utils'

import type {
  GetSalesLimitations,
  GetSalesLimitationsMetadata,
} from './sales-limitations.types'

/**
 * Retrieve sales limitations.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Sales-limitation/operation/get-bm-merchants-sales-limitations}
 */
export const getSalesLimitations = createHttpEndpoint<GetSalesLimitations>({
  method: 'GET',
  operationId: 'getSalesLimitations',
  path: '/bm/merchants/sales-limitation',
})

/**
 * Create a sales limitation as an authenticated admin.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Sales-limitation/operation/post-bm-merchants-sales-limitation}
 */
export const createSalesLimitation = createHttpEndpoint({
  method: 'POST',
  operationId: 'createSaleLimitation',
  path: '/bm/merchants/sales-limitation',
})

/**
 * Update a sales limitation as an authenticated admin.
 *
 *  * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#/Sales%20limitation/post-bm-merchants-sales-limitation}
 */
export const editSalesLimitation = createHttpEndpoint({
  method: 'PUT',
  operationId: 'editSaleLimitation',
  path: '/bm/merchants/sales-limitation/:salesLimitationId',
})

/**
 * Delete a sales limitation as an authenticated admin.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Sales-limitation/operation/delete-bm-merchants-sales-limitation-sales_limit_id}
 */
export const deleteSalesLimitation = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deleteSaleLimitation',
  path: '/bm/merchants/sales-limitation/:salesLimitationId',
})

/**
 * Retrieve sales limitations metadata.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Sales-limitation/operation/get-bm-merchants-sales-limitation-metadata}
 */
export const getSalesLimitationsMetadata =
  createHttpEndpoint<GetSalesLimitationsMetadata>({
    method: 'GET',
    operationId: 'getSalesLimitationsMetadata',
    path: '/bm/merchants/sales-limitation/metadata',
  })
